import request from '@/api/request.js'

// 新增
export function NewsDetailInsert(data) {
    return request({
        url: '/api/news/newsdetailinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function NewsDetailDelete(id) {
    return request({
        url: `/api/news/newsdetaildelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function NewsDetailUpdate(id, data) {
    return request({
        url: `/api/news/newsdetailupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function NewsDetailGetById(id) {
    return request({
        url: `/api/news/getnewsdetailbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function NewsDetailGetList(params) {
    return request({
        url: '/api/news/getnewsdetaillist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function NewsDetailGetPageList(params) {
    return request({
        url: '/api/news/getnewsdetailpagelist',
        method: 'get',
        params: params
    })
}